import React, {useEffect, useMemo} from 'react';
import reportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const EventLocal = ({data}) => {
    const eventLocal = data?.locationType ?? [];

    const top10 = useMemo(() => {
        const localData = eventLocal.slice(0, 10);

        return {
            labels: localData.map(item => reportUtils.formatText(item.type)),
            values: localData.map(item => item.qty)
        };
    }, [eventLocal]);

    const eventToExport = useMemo(() => {
        return {
            labels: eventLocal.map(item => reportUtils.formatText(item.type)),
            values: eventLocal.map(item => item.qty)
        };
    }, [eventLocal]);

    useEffect(() => {
        if (top10.labels.length > 0) {
            GraphicUtils.barChart('event-local', top10.values, top10.labels);
        }

        if (eventToExport.labels.length > 0) {
            ReportUtils.createExportableTable(eventToExport.labels, eventToExport.values, `Tipo do local`);
        }

    }, [top10, eventToExport]);

    return (
        <>
            <div className="chart-report" title={"Tipo do evento"}>
                <span id={`event-local-title`} className="chart-title " htmlFor={"event-local"} >Tipo do local {eventToExport.labels.length > 9 ? "(TOP 10)" : "" }</span>
                <div className="mt-3" id={"event-local"}></div>
            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default EventLocal;